const e=({css:e})=>(e[`so-global-region-logo-content`]?`
    .html-email-logo-column-strip-layout > table > tbody > tr > td {
      padding-right: 0px!important;
      padding-left: 0px!important;
    }
  `:``).concat(`
    .section-link-image > table > tbody > tr > td {
      padding-bottom: 0px!important;
    }

    .section-link-text > table > tbody > tr > td {
      padding-top: 24px!important;
    }
  `);export{e as getActualSectionPaddingForSmallScreenCss};
//# sourceMappingURL=get-section-padding-tweaks-for-small-screen-css.js.map